enum Pages {
  PRIVACY_POLICY = '/privacy-policy/',
  TERMS_AND_CONDITIONS = '/terms-and-conditions/',
}

export default Pages
